import SignatoryRepository from "../domain/data/SignatoryRepository";
import Signatory, { SignatoryLogin } from "../domain/entities/Signatory";
import User from "../domain/entities/User";
import { signatories } from "./InitData";

export default class MockSignatoryRepository implements SignatoryRepository {
  private static signatories: Signatory[] = signatories;

  async login(
    username: string,
    password: string
  ): Promise<{ signatory: Signatory; signatures: string[] } | undefined> {
    return {
      signatory: MockSignatoryRepository.signatories[0],
      signatures: [],
    };
  }
  async requestPasswordUpdate(email: string): Promise<boolean> {
    return true;
  }
  async passwordUpdate(
    username: string,
    password: string,
    otp: string
  ): Promise<Signatory | undefined> {
    return MockSignatoryRepository.signatories[0];
  }
  async saveSignatory(signatory: Signatory) {
    MockSignatoryRepository.signatories.push(signatory);
    return signatory;
  }
  async saveLanguageSignatory(language: string, signatoryEmail: string): Promise<Signatory> {
    throw new Error("Method not implemented.");
  }
  async searchSignatory(user: User, email: string) {
    return MockSignatoryRepository.signatories.find(
      (signatory) => signatory.email === email
    );
  }
  async searchSignatories(user: User, term: string) {
    return MockSignatoryRepository.signatories;
  }
  async getSignatoryByShortIdThenVerify(shortid: string, password: string): Promise<SignatoryLogin>{
    throw new Error("Method not implemented.");
  }
 
  async getSignatoryByShortId(shortid: string): Promise<Signatory> {
    throw new Error("Method not implemented.");
  }
  async getSignatoryByEmail(email: string): Promise<Signatory> {
    throw new Error("Method not implemented.");
  }
  async sendNewPin(shortid: string, forceResend?: boolean, email?: string): Promise<boolean> {
    throw new Error("Method not implemented.");
  }
}
